<template>
  <v-form v-model="isFormValid" ref="form">
    <dashboard-header :text="item ? $t('ui.sosCaseUpdate'): $t('ui.sosCaseCreate')" :on-back="goBack"/>
    <div class="d-flex justify-center align-center">
      <v-card
          elevation="0"
          :loading="loading"
          class="card-border-10 w-75">

          <v-card
              class="m-4"
              outlined>
              <div class="d-flex custom-card-head p-4">
            <div class="d-inline text-sm-h5">{{ $t('ui.caption') }}</div>
            </div>
            <v-divider class="ma-0"></v-divider>

            <div class="px-6 pt-6">
                <div class="d-flex">
                  <div class="text-h6 mark-title">*</div>
                  <p class="ms-1 text-sm-h5">{{ $t('sosCase.selectSosCaseType') }}</p>
                </div>
                <v-select
                    v-model="specialSosType"
                    :items="listSpecialSosType"
                    :placeholder="select"
                    item-text="name"
                    item-value="value"
                    dense
                    outlined
                />

              <!-- Loại SOS -->
              <div class="d-flex">
                <div class="text-h6 mark-title">*</div>
                <p class="ms-1 text-sm-h5">{{ $t('sosCase.sosType') }}</p>
              </div>
              <v-select
                  v-model="selectedSosType"
                  :items="listSosType"
                  :placeholder="select"
                  item-text="name"
                  deletable-chips
                  return-object
                  dense
                  outlined>
              </v-select>

              <!-- Khoa phát báo động -->
              <div v-if="!checkOutOfHospital()">
                <div class="d-flex">
                  <div class="text-h6 mark-title">*</div>
                  <p class="ms-1 text-sm-h5">{{ $t('sosCase.source') }}</p>
                </div>
                <v-select
                    v-model="selectedSource"
                    :items="listSource"
                    :placeholder="select"
                    item-text="name"
                    return-object
                    dense
                    outlined
                    class="sos-select-with-chips single-select-ellipsis"
                    :menu-props="menuPropsSource"
                    ref="sourceSelect"
                    @focus="recalcSourceWidth"
                    @update:menu="onSourceMenuToggle">
                  <template v-slot:selection="{ item }">
                    <span class="single-selection-text">{{ item && item.name }}</span>
                  </template>
                </v-select>
              </div>

              <!-- Khoa phát báo động cho liên viện -->
              <div v-if="checkOutOfHospital()">
                <div class="d-flex">
                  <div class="text-h6 mark-title">*</div>
                  <p class="ms-1 text-sm-h5">{{ $t('sosCase.source') }}</p>
                </div>
                <v-select
                    v-model="selectedSource"
                    :items="departmentInChare ? [departmentInChare] : []"
                    :placeholder="select"
                    item-text="name"
                    return-object
                    disabled
                    dense
                    outlined
                    class="sos-select-with-chips single-select-ellipsis"
                    :menu-props="menuPropsSource"
                    ref="sourceSelect">
                  <template v-slot:selection="{ item }">
                    <span class="single-selection-text">{{ item && item.name }}</span>
                  </template>
                </v-select>
                <div class="text-caption text-grey mt-1" v-if="!departmentInChare">
                  {{ $t('warning.noInterHospitalDepartment') }}
                </div>
              </div>

              <!-- Khoa nhận báo động -->
              <div v-if="!checkOutOfHospital()">
                <div class="d-flex">
                  <div class="text-h6 mark-title">*</div>
                  <p class="ms-1 text-sm-h5">{{ $t('sosCase.targets') }}</p>
                </div>

                <!-- Chips display above select -->
                <div v-if="selectedTargets && selectedTargets.length > 0" class="chips-container">
                  <v-chip
                    v-for="item in selectedTargets"
                    :key="item.departmentId"
                    class="custom-chip-employee"
                  >
                    <span class="chip-text ellipsis-one-line">{{ item.name }}</span>
                    <v-icon class="chip-close" small color="grey" @click="removeTargetChip(item)">mdi-close</v-icon>
                  </v-chip>

                </div>

                <v-select
                    v-model="selectedTargets"
                    :items="listTargets"
                    :placeholder="select"
                    item-text="name"
                    small-chips
                    multiple
                    deletable-chips
                    return-object
                    dense
                    outlined
                    class="sos-select-with-chips"
                    :menu-props="menuPropsTargets"
                    ref="targetsSelect"
                    @focus="recalcTargetsWidth"
                    @update:menu="onTargetsMenuToggle">
                    <template v-slot:selection>
                      <!-- Hide all selections since we show chips above -->
                    </template>
                </v-select>
              </div>

              <!-- Bệnh viện nhận báo động -->
              <div v-if="checkOutOfHospital()">
                <div class="d-flex">
                  <div class="text-h6 mark-title">*</div>
                  <p class="ms-1 text-sm-h5">{{ $t('sosCase.hospitalReceivedAlarm') }}</p>
                </div>

                <!-- Chips display above select -->
                <div v-if="selectedHospital && selectedHospital.length > 0" class="chips-container">
                  <v-chip
                    v-for="item in selectedHospital"
                    :key="item.hospitalId"
                    class="custom-chip-employee"
                  >
                    <span class="chip-text ellipsis-one-line">{{ item.name }}</span>
                    <v-icon class="chip-close" small color="grey" @click="removeHospitalChip(item)">mdi-close</v-icon>
                  </v-chip>

                </div>

                <v-select
                    v-model="selectedHospital"
                    :items="listHospital"
                    :placeholder="select"
                    item-text="name"
                    small-chips
                    multiple
                    deletable-chips
                    return-object
                    dense
                    @focus="recalcHospitalWidth"
                    @update:menu="onHospitalMenuToggle"
                    outlined
                    class="sos-select-with-chips"
                    :menu-props="menuPropsHospital"
                    ref="hospitalSelect">
                    <template v-slot:selection>
                      <!-- Hide all selections since we show chips above -->
                    </template>
                </v-select>
              </div>


              <!-- Nội dung báo động -->
              <div>
                <div class="d-flex">
                  <p class="ms-1 text-sm-h5">{{ $t('sosCase.sosMessage') }}</p>
                </div>
                <v-select
                    v-model="selectedSosMessage"
                    :items="listSosMessage"
                    :placeholder="select"
                    item-text="name"
                    return-object
                    dense
                    outlined>
                </v-select>
              </div>

            </div>

          </v-card>
          <div class=" m-4">
          <v-btn
              :disabled="saveDisabled"
              :outlined="saveDisabled"
              class="mt-6 no-uppercase"
              elevation="0"
              @click="checkForm"
              color="info">
            {{ $t('ui.save') }}
          </v-btn>
          </div>

      </v-card>
    </div>

  </v-form>
</template>

<script>
import {API2} from "../../api";
import {SOS_TYPE, SPECIAL_SOS_TYPE} from "../../config/constant";
import i18n from "../../lang/i18n";
import DashboardHeader from "../component/DashboardHeader";
import mixin from "../../mixin";

export default {
  components: {DashboardHeader},
  mixins: [mixin],
  props: {
    openTab: {
      type: Function,
      required: true
    },
    item: {
      type: Object,
    },
  },
  data() {
    return {
      listSosType: [],
      selectedSosType: null,
      listSource: [],
      selectedSource: null,
      listTargets: [],
      selectedTargets: null,
      // sos message
      listSosMessage: [],
      selectedSosMessage: null,
      // hospital
      listHospital: [],
      selectedHospital: null,
      // department in charge
      departmentInChare: null,
      // store select widths to lock dropdown width
      selectTargetsWidth: null,
      selectHospitalWidth: null,
      selectSourceWidth: null,
      listSpecialSosType: [
        {name: 'Thường', value: 1},
        {name: 'Code Blue', value: 2},
        {name: 'Bạo hành', value: 3}
      ],
      specialSosType: 1,
    };
  },
  watch: {
    selectedSource: function (newValue) {
      // Recalculate menu width after selection to keep dropdown equal to select's width
      this.recalcSourceWidth()
      return newValue;
    },
    selectedSosType: {
      handler(newValue) {
        if (newValue && newValue.alertInterHospital === 1) {
          // Auto-prefill source department for inter-hospital types
          this.selectedSource = this.departmentInChare;
        } else {
          // Clear source for regular types if it was set from inter-hospital
          if (this.selectedSource === this.departmentInChare) {
            this.selectedSource = null;
          }
        }
      },
      immediate: false
    },
    selectedTargets() {
      // Keep targets menu width synced after changes
      this.recalcTargetsWidth()
    },
    selectedHospital() {
      // Keep hospital menu width synced after changes
      this.recalcHospitalWidth()
    },
    departmentInChare: {
      handler(newValue) {
        // Update selectedSource when departmentInChare changes and we have inter-hospital type selected
        if (this.selectedSosType && this.selectedSosType.alertInterHospital === 1) {
          this.selectedSource = newValue;
        }
      },
      immediate: false
    }
  },
  mounted() {
    this.onTab(this.item)
    this.$nextTick(() => {
      this.calculateSelectWidths()
      window.addEventListener('resize', this.calculateSelectWidths)
    })
  },
  computed: {
    saveDisabled() {
      return false
    },
    labelSosType: () => i18n.t("sosCase.selectSosType"),
    labelSource: () => i18n.t("sosCase.source"),
    placeholderSelectSource: () => i18n.t("sosCase.selectSource"),
    labelTargets: () => i18n.t("sosCase.targets"),
    placeholderSelectTargets: () => i18n.t("sosCase.selectTargets"),
    labelSosMessage: () => i18n.t("sosCase.sosMessage"),
    placeholderSosMessage: () => i18n.t("sosCase.selectSosMessage"),
    labelHospital: () => i18n.t("sosCase.hospitalReceivedAlarm"),
    placeholderSelectHospital: () => i18n.t("sosCase.selectHospital"),
    select: () => i18n.t("base.selectOption"),
    menuPropsTargets() {
      return {
        offsetY: true,
        nudgeBottom: 4,
        contentClass: 'targets-dropdown-menu',
        maxWidth: this.selectTargetsWidth || this.getSelectWidth(this.$refs.targetsSelect),
        minWidth: this.selectTargetsWidth || this.getSelectWidth(this.$refs.targetsSelect)
      }
    },
    menuPropsHospital() {
      return {
        offsetY: true,
        nudgeBottom: 4,
        contentClass: 'hospital-dropdown-menu',
        maxWidth: this.selectHospitalWidth || this.getSelectWidth(this.$refs.hospitalSelect),
        minWidth: this.selectHospitalWidth || this.getSelectWidth(this.$refs.hospitalSelect)
      }
    },
    menuPropsSource() {
      return {
        offsetY: true,
        nudgeBottom: 4,
        contentClass: 'source-dropdown-menu',
        maxWidth: this.selectSourceWidth || this.getSelectWidth(this.$refs.sourceSelect),
        minWidth: this.selectSourceWidth || this.getSelectWidth(this.$refs.sourceSelect)
      }
    }
  },

  methods: {

    getSelectWidth(ref) {
      // Use offsetWidth to include borders and avoid fractional rounding issues
      if (!ref || !ref.$el) return 180
      const width = ref.$el.offsetWidth
      return Math.max(180, width)
    },
    calculateSelectWidths() {
      this.$nextTick(() => {
        if (this.$refs.targetsSelect && this.$refs.targetsSelect.$el) {
          this.selectTargetsWidth = this.getSelectWidth(this.$refs.targetsSelect)
        }
        if (this.$refs.hospitalSelect && this.$refs.hospitalSelect.$el) {
          this.selectHospitalWidth = this.getSelectWidth(this.$refs.hospitalSelect)
        }
        if (this.$refs.sourceSelect && this.$refs.sourceSelect.$el) {
          this.selectSourceWidth = this.getSelectWidth(this.$refs.sourceSelect)
        }
      })
    },
    onTab(item) {
      this.getData(item);
    },
    goBack() {
      this.openTab(0)
    },
    recalcSourceWidth() {
      this.$nextTick(() => {
        if (this.$refs.sourceSelect && this.$refs.sourceSelect.$el) {
          this.selectSourceWidth = this.getSelectWidth(this.$refs.sourceSelect)
          // If menu is open, also force set width for menu container to avoid mismatch
          const menuEl = document.querySelector('.v-menu__content.source-dropdown-menu')
          if (menuEl && this.selectSourceWidth) {
            menuEl.style.minWidth = this.selectSourceWidth + 'px'
            menuEl.style.maxWidth = this.selectSourceWidth + 'px'
            menuEl.style.width = this.selectSourceWidth + 'px'
          }
        }
      })
    },
    onSourceMenuToggle(isOpen) {
      if (isOpen) {
        this.recalcSourceWidth()
      }
    },
    recalcTargetsWidth() {
      this.$nextTick(() => {
        if (this.$refs.targetsSelect && this.$refs.targetsSelect.$el) {
          this.selectTargetsWidth = this.getSelectWidth(this.$refs.targetsSelect)
          const menuEl = document.querySelector('.v-menu__content.targets-dropdown-menu')
          if (menuEl && this.selectTargetsWidth) {
            menuEl.style.minWidth = this.selectTargetsWidth + 'px'
            menuEl.style.maxWidth = this.selectTargetsWidth + 'px'
            menuEl.style.width = this.selectTargetsWidth + 'px'
          }
        }
      })
    },
    onTargetsMenuToggle(isOpen) {
      if (isOpen) {
        this.recalcTargetsWidth()
      }
    },
    recalcHospitalWidth() {
      this.$nextTick(() => {
        if (this.$refs.hospitalSelect && this.$refs.hospitalSelect.$el) {
          this.selectHospitalWidth = this.getSelectWidth(this.$refs.hospitalSelect)
          const menuEl = document.querySelector('.v-menu__content.hospital-dropdown-menu')
          if (menuEl && this.selectHospitalWidth) {
            menuEl.style.minWidth = this.selectHospitalWidth + 'px'
            menuEl.style.maxWidth = this.selectHospitalWidth + 'px'
            menuEl.style.width = this.selectHospitalWidth + 'px'
          }
        }
      })
    },
    onHospitalMenuToggle(isOpen) {
      if (isOpen) {
        this.recalcHospitalWidth()
      }
    },
    async getData(item) {
      if(item?.sosCaseId) {
        this.detail = await this.get(API2.SOS_CASE, {path: item?.sosCaseId})
        if (!this.detail) {
          // No data found, go back to list
          this.goBack();
        }
        this.parseData(item);
      } else {
        this.parseData(item);
      }
    },
    parseData(item) {
        if (item) {
          if (typeof item.specialType === 'string') {
            // Nếu specialType là chuỗi (VD: "VIOLENCE"), chuyển đổi nó sang số tương ứng
            const typeKey = Object.keys(SPECIAL_SOS_TYPE).find(key => key === item.specialType.toUpperCase());
            this.specialSosType = typeKey ? SPECIAL_SOS_TYPE[typeKey] : 1;
          } else {
            // Nếu đã là số, sử dụng trực tiếp
            this.specialSosType = item.specialType;
          }
        } else {
          this.specialSosType = 1;
        }

        this.selectedSosType = null
        this.selectedSource = null
        this.selectedTargets = null
        this.selectedSosMessage = null
        this.selectedHospital = null
        this.getListSosType(item)
        this.getlistFilterTable(item)
        this.getListSosMessage(item)
        this.getListHospital(item)
        this.getDepartmentInCharge()
    },
    async getListSosType(item) {
      let res = await this.get(API2.SOS_TYPE)
      if (res) {
        this.listSosType = res.data;
        if (item) {
          this.selectedSosType = this.listSosType.find(sosType =>
              sosType.sosTypeId === item.sosTypeInfo.sosTypeId
          );
          if (!this.selectedSosType) this.selectedSosType = this.listSosType[0];

          // Trigger watcher to prefill source department for inter-hospital types
          if (this.selectedSosType && this.selectedSosType.alertInterHospital === 1 && this.departmentInChare) {
            this.selectedSource = this.departmentInChare;
          }
        }
      }
    },
    async getlistFilterTable(item) {
      let res = await this.get(API2.DEPARTMENT, { sortBy: "createdAt", orderBy: "DESC" })
      if (res) {
        this.listSource = res.data;
        this.listTargets = res.data;


        if (item) {
          this.selectedSource = this.listSource.find(value =>
              item.source.toString() === value.departmentId.toString()
          );
          const _targets = JSON.parse(item.targets);
          this.selectedTargets = this.listTargets.filter(
              value => _targets.includes(value.departmentId)
          );
        }
      }
    },
    async getListSosMessage(item) {
      let res = await this.get(API2.SOS_MESSAGE)
      if (res) {
        this.listSosMessage = res.data.map(value => {
          return {...value, name: value.message};
        });
        if (item) {
          this.selectedSosMessage = this.listSosMessage.find(value => item.messageId === value.messageId);
        }
      }
    },
    async getListHospital(item) {
      let res = await this.get(API2.SOS_CASE_LIST_HOSPITAL)
      if (res) {
        this.listHospital = res.map(value => {
          return {
            ...value,
            name: value.name
          };
        });

        if (item) {
          const listHospitalId = item.targetsInfo.map(
              _department => _department.hospitalId
          );
          this.selectedHospital = this.listHospital.filter(
              value => listHospitalId.includes(value.hospitalId)
          );
        } else {
          this.selectedHospital = null;
        }
      }
    },
    async getDepartmentInCharge() {
      let res = await this.get(API2.SOS_CASE_DEPARTMENT_IN_CHARGE)
      if (res) this.departmentInChare = res;
    },
    async checkForm() {
      // if (this.specialSosType === 2 || this.specialSosType === 3) { // Code Blue or Violence
      //   let res = await this.get(API2.SOS_CASE)
      //   if (res && res.data) {
      //     const existedCase = res.data.find(item => item.specialType === this.specialSosType && (!this.item || this.item.sosCaseId !== item.sosCaseId))
      //     if (existedCase) {
      //       const typeName = this.listSpecialSosType.find(item => item.value === this.specialSosType).name
      //       return this.showToast("warning", i18n.t("warning.warning"), `Đã có báo động được cấu hình cho SOS ${typeName}.`);
      //     }
      //   }
      // }
      if (!this.selectedSosType) {
        return this.showToast("warning", i18n.t("warning.warning"), i18n.t("warning.selectedSosType"))
      }
      if (
          this.selectedSosType.sosTypeId !== SOS_TYPE.OUT_THE_HOSPITAL &&
          !this.selectedSource
      ) {
        return this.showToast("warning", i18n.t("warning.warning"), i18n.t("warning.selectSource"))
      }
      if (
          !this.checkOutOfHospital() &&
          (!this.selectedTargets || this.selectedTargets.length === 0)
      ) {
        return this.showToast("warning", i18n.t("warning.warning"), i18n.t("warning.selectTargets"))
      }
      if (
          this.checkOutOfHospital() &&
          (!this.selectedHospital || this.selectedHospital.length === 0)
      ) {
        return this.showToast("warning", i18n.t("warning.warning"), i18n.t("warning.selectHospital"))
      }
      if (this.selectedSosType && this.selectedSosType.alertInterHospital === 1) {
        if (!this.departmentInChare) {
          return this.showToast("warning", i18n.t("warning.warning"), i18n.t("warning.noInterHospitalDepartment"))
        }
        if (!this.selectedSource || this.selectedSource.departmentId !== this.departmentInChare.departmentId) {
          return this.showToast("warning", i18n.t("warning.warning"), i18n.t("warning.departmentInChare"))
        }
      }
      this.onSave();
    },
    async onSave() {
      // console.log("selectedSosMessage", this.selectedSosMessage)
      let source = null,
          targets = [];
      if (!this.item) {
        if (this.checkOutOfHospital()) {
          source = this.departmentInChare.departmentId;
          targets = JSON.stringify(
              this.selectedHospital.map(hospital => {
                // Handle different possible data structures for department in charge
                if (hospital.departmentInCharge && hospital.departmentInCharge.departmentId) {
                  return hospital.departmentInCharge.departmentId;
                } else if (hospital.Department && hospital.Department.departmentId) {
                  return hospital.Department.departmentId;
                } else if (hospital.Departments && hospital.Departments.length > 0) {
                  // Find department with inCharge = 1
                  const inChargeDept = hospital.Departments.find(dept => dept.inCharge === 1);
                  return inChargeDept ? inChargeDept.departmentId : null;
                } else {
                  // No department in charge found for hospital
                  return null;
                }
              }).filter(id => id !== null) // Remove null values
          );
        } else {
          source = this.selectedSource.departmentId;
          targets = JSON.stringify(
              this.selectedTargets.map(value => value.departmentId)
          );
        }

        let res = await this.post(API2.SOS_CASE, {
          source,
          targets,
          description: this.selectedSosMessage ? this.selectedSosMessage.name : "",
          messageId: this.selectedSosMessage?.messageId,
          sosTypeId: this.selectedSosType.sosTypeId,
          specialType: this.specialSosType
        })
        if (!res) return
        this.showToast("success", i18n.t("base.notification"), i18n.t("base.createSuccessful"))
        this.openTab(0)
      } else {
        if (this.checkOutOfHospital()) {
          source = this.departmentInChare.departmentId;
          targets = JSON.stringify(
              this.selectedHospital.map(hospital => {
                // Handle different possible data structures for department in charge
                if (hospital.departmentInCharge && hospital.departmentInCharge.departmentId) {
                  return hospital.departmentInCharge.departmentId;
                } else if (hospital.Department && hospital.Department.departmentId) {
                  return hospital.Department.departmentId;
                } else if (hospital.Departments && hospital.Departments.length > 0) {
                  // Find department with inCharge = 1
                  const inChargeDept = hospital.Departments.find(dept => dept.inCharge === 1);
                  return inChargeDept ? inChargeDept.departmentId : null;
                } else {
                  // No department in charge found for hospital
                  return null;
                }
              }).filter(id => id !== null) // Remove null values
          );
        } else {
          source = this.selectedSource.departmentId;
          targets = JSON.stringify(
              this.selectedTargets.map(value => value.departmentId)
          );
        }
        let res = await this.put(API2.SOS_CASE,
            {
              path: this.item.sosCaseId,
              source,
              targets,
              description: this.selectedSosMessage ? this.selectedSosMessage.name : "",
              messageId: this.selectedSosMessage?.messageId,
              sosTypeId: this.selectedSosType.sosTypeId,
              specialType: this.specialSosType
            }
        )
        if (!res) return
        this.showToast("success", i18n.t("base.notification"), i18n.t("base.updateSuccessful"))
        this.openTab(0)
      }
    },
    // checkShowMessage() {
    //   if (!this.selectedSosType || !this.selectedSosType.sosTypeId) {
    //     return false;
    //   }
    //   return this.selectedSosType.sosTypeId !== SOS_TYPE.VIOLENCE
    // },
    checkOutOfHospital() {
      if (this.selectedSosType && this.selectedSosType.alertInterHospital === 1) {
        return true;
      }
      return false;
    },
    shortenText(text, maxLength) {
      return text.length > maxLength ? text.substring(0, maxLength) + "…" : text;
    },
    removeTargetChip(item) {
      const index = this.selectedTargets.findIndex(target => target.departmentId === item.departmentId)
      if (index >= 0) {
        this.selectedTargets.splice(index, 1)
      }
    },
    removeHospitalChip(item) {
      const index = this.selectedHospital.findIndex(hospital => hospital.hospitalId === item.hospitalId)
      if (index >= 0) {
        this.selectedHospital.splice(index, 1)
      }
    },
  }
};
</script>
<style scoped>
.card-border-10 >>> .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
  color: rgba(217, 217, 217, 1);
}

/* Copy exact styling from permission module - custom-chip-employee */
.custom-chip-employee {
  border: 1px solid #D9D9D9 !important;
  border-radius: 2px;
  background-color: #FAFAFA !important;
}

/* Select field styling */

/* Dropdown menu styling for Targets and Hospital - match select width and single-line items */
.targets-dropdown-menu,
.hospital-dropdown-menu,
.source-dropdown-menu {
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid #e0e0e0 !important;
  overflow: hidden !important;
}
.targets-dropdown-menu .v-list,
.hospital-dropdown-menu .v-list {
  padding: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
  overflow: hidden !important;
}
.targets-dropdown-menu .v-list-item,
.hospital-dropdown-menu .v-list-item {
  padding: 12px 16px !important;
  min-height: 44px !important;
  border-bottom: 1px solid #f5f5f5;
  width: 100% !important;
  max-width: 100% !important;
  overflow: hidden !important;
}
.targets-dropdown-menu .v-list-item:last-child,
.hospital-dropdown-menu .v-list-item:last-child {
  border-bottom: none;
}
.targets-dropdown-menu .v-list-item__title,
.hospital-dropdown-menu .v-list-item__title {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #333 !important;
  overflow: hidden !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
  max-width: 100% !important;
  display: block !important;
}

.sos-select-with-chips {
  margin-top: 0;
  margin-bottom: 24px;
}

/* Make single select (Khoa phát báo động) show ellipsis when text is long */
.single-select-ellipsis >>> .v-input__slot { overflow: hidden; }
/* Keep dense height fixed to avoid growing when text is long */
.single-select-ellipsis.v-input--dense >>> .v-input__slot { min-height: 40px; }
.single-select-ellipsis >>> .v-select__selections {
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
}
/* Fallback when not using custom selection slot */
.single-select-ellipsis >>> .v-select__selection,
.single-select-ellipsis >>> .v-select__selection--comma {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
/* Our custom selection span */
.single-selection-text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
/* Prevent the internal input from expanding layout */
.single-select-ellipsis >>> .v-select__selections input {
  width: 0 !important;
  min-width: 0 !important;
  padding: 0 !important;
}

/* Ellipsis for dropdown items */
.ellipsis-one-line {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* Chips container above selects - align left with select and add spacing */
.chips-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  margin: 4px 0 12px 0; /* spacing above and below chips */
}

/* Ensure chip content is single line with ellipsis and smaller close icon */
.custom-chip-employee >>> .v-chip__content {
  display: flex;
  align-items: center;
  max-width: 100%;
}
.custom-chip-employee .chip-text {
  flex: 1 1 auto;
  min-width: 0; /* allow flex child to shrink for ellipsis */
}
.custom-chip-employee .chip-close {
  margin-left: 4px;
}

</style>



/* Chips container ensures wrapping and prevents parent width from stretching */
.chips-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
}

/* Prevent chip from exceeding container width */

/* Make each chip occupy full container width so text can ellipsis properly and prevent parent stretching */
.chips-container .v-chip.custom-chip-employee {
  width: 100% !important;
  justify-content: space-between; /* push text and close icon apart */
}

.custom-chip-employee {
  max-width: 100%;
}

/* Ensure chip content is single line with ellipsis and smaller close icon */
.custom-chip-employee >>> .v-chip__content {
  display: flex;
  align-items: center;
  max-width: 100%;
}
.custom-chip-employee .chip-text {
  flex: 1 1 auto;
  min-width: 0; /* allow flex child to shrink for ellipsis */
}
.custom-chip-employee .chip-close {
  margin-left: 4px;
}
